<template>
  <div class="whaty-grid-search-form mSearch" ref="mSearchDiv">
    <div v-show="showSearchMask" class="mSearch-mask" title="禁用，请先取消选择全部"></div>
    <div class="mSearch-form-group" @keydown.enter="handleSearch">
      <ul class="clearfix">
        <li
          v-for="item in gridConfig.listColumnConfig"
          v-if="item.search && item.type !== 'file'"
          class="mSearch-cell">
          <div class="mSearch-form">
            <div class="form-con">
              <el-tooltip class="item" effect="dark" :content="item.name" placement="top" :open-delay="800" :enterable="false">
                <div class="input-wrap">

                  <el-input
                    v-if="(item.type === 'text' || item.type === 'textArea') && item.dataIndex !== 'stuNum'"
                    v-model="searchParams[item.dataIndex]"
                    :placeholder="item.name"
                    size="mini"
                    clearable
                  ></el-input>

                  <whaty-search-input-text
                    v-if="(item.type === 'text' || item.type === 'textArea') && item.dataIndex === 'stuNum'"
                    v-model="searchParams[item.dataIndex]"
                    :dataIndex="item.dataIndex"
                    :gridConfig="gridConfig"
                    :gridConfigUrl="gridConfigUrl"
                    :placeholder="item.name"
                  ></whaty-search-input-text>

                  <whaty-search-input-number
                    v-if="item.type === 'number'"
                    v-model="searchParams[item.dataIndex]"
                    :dataIndex="item.dataIndex"
                    :gridConfig="gridConfig"
                    :gridConfigUrl="gridConfigUrl"
                    :placeholder="item.name"
                  ></whaty-search-input-number>

                  <el-select
                    :ref="selectRefPrefix + item.uid"
                    :loading="!!selectLoadingMap[item.uid]"
                    :no-data-text="selectNoDataTextMap[item.uid] || '无数据'"
                    v-if="item.type === 'select'"
                    v-model="searchParams[item.dataIndex]"
                    :placeholder="item.name"
                    size="mini" filterable clearable
                    @focus="handleSelectFocus(item)"
                    @change="handleSelectChange(item)"
                  >
                    <el-option
                      v-for="op in selectDataList[item.uid]" :key="op[0]" :value="op[1]">
                    </el-option>
                  </el-select>

                  <whaty-select
                    v-if="item.type === 'remote_select'"
                    v-model="searchParams[item.dataIndex]"
                    :url="remoteSelectDataUrl"
                    :queryParams="{actionId: gridConfig.gridId, columnDataIndex: item.dataIndex}"
                    :placeholder="item.name"
                    :valueIndex="1"
                    @select-data-change="handleWhatySelectDataChange($event, item)"
                    @change="handleSelectChange(item)"
                  >
                  </whaty-select>

                  <el-date-picker
                    v-if="item.type === 'date'"
                    v-model="searchParams[item.dataIndex]"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    :placeholder="item.name"
                    :start-placeholder="item.name"
                    :end-placeholder="item.name"
                    :picker-options="pickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    popper-class="whaty-el-date-picker"
                  >
                  </el-date-picker>

                  <el-date-picker
                    v-if="item.type === 'datetime'"
                    v-model="searchParams[item.dataIndex]"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    :start-placeholder="item.name"
                    :end-placeholder="item.name"
                    :picker-options="pickerOptions"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="mini"
                    popper-class="whaty-el-date-picker"
                  >
                  </el-date-picker>

                </div>
              </el-tooltip>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="mSearch-submit-area">
      <a @click="handleShowSaveSearchGroupDialog" href="javascript:" ondragstart="return false" class="btn btn-hollow">保存搜索条件</a>
      <div class="mSearch-filter">
        <el-select
          @focus.once="handleSearchGroupSelectFocus($event)"
          @visible-change="closeSearchGroupDropSubmenu"
          @change="handleSearchGroupChange"
          v-model="selectedSavedSearchParams" placeholder="我的查询" size="mini" filterable clearable popper-class="search-select">
          <el-option
            v-for="item in userGridConfigList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            <a href="javascript:" class="drop-link" :class="{'drop-select': item.id === dropLinkSelect.id}">
              <span class="drop-txt">{{ item.name }}</span>
              <i @click.stop="showSearchGroupDrop(item, $event)" class="mng icon-moreDots drop-ico-suf drop-ico-more"></i>
            </a>
          </el-option>
        </el-select>
        <div
          v-show="showDropSubmenu"
          :style="[{'left': dropSubmenuLeft + 'px'}, {'top': dropSubmenuTop + 'px'}]"
          class="drop drop-submenu">
          <ul>
            <li @click="handleShowUpdateSearchGroupDialog" class="drop-list"><a href="javascript:" class="drop-link">修改名称</a></li>
            <li @click="deleteSearchGroup" class="drop-list"><a href="javascript:" class="drop-link">删除</a></li>
          </ul>
        </div>
      </div>
      <a @click="handleSearch" href="javascript:" ondragstart="return false" class="btn btn-solid">搜索</a>
      <a @click="clearSearchForm" href="javascript:" ondragstart="return false" class="btn btn-hollow">重置</a>
    </div>

    <whaty-dialog :title="searchGroupSaveOrUpdateFlag === 1 ? '保存筛选名称' : '修改筛选名称'"
                  :visible.sync="showSaveSearchGroupDialog" width="30%"
                  @yes-btn-click="handleSearchGroupFormSubmit">
      <div class="popup-content-in">
        <div class="form-row form-pretitle">
          <div class="form-tit">名称</div>
          <div class="form-con">
            <div class="input-wrap">
              <input v-model.trim="searchGroupInputValue" class="form-control" value="" placeholder="请输入名称">
            </div>
          </div>
        </div>
      </div>
    </whaty-dialog>
  </div>
</template>
<script>
  import util from '../../libs/util'
  import {ELEMENT_DATE_PICKER_OPTIONS_1} from '../../libs/constants'
  import WhatyDialog from '../dialog/dialog.vue'
  import WhatySelect from '../whaty-select/whaty-select'
  import WhatySearchInputText from '../whaty-search-input-text/index'
  import WhatySearchInputNumber from '../whaty-search-input-number/index'

  export default {
    components: {
      WhatySearchInputNumber,
      WhatySearchInputText,
      WhatySelect,
      WhatyDialog
    },
    name: 'grid-search-form',
    props: {
      gridConfig: { // grid配置
        type: Object,
        default() {
          return {}
        }
      },
      gridConfigUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        selectLoadingMap: {}, // select字段的loading状态
        selectNoDataTextMap: {}, // select字段无匹配数据时的提示文本
        selectLoadStatusMap: {}, // select字段是否load标识
        showDropSubmenu: false, // 是否显示搜索组的子菜单
        dropLinkSelect: {}, // 当前显示了子菜单的搜索条件组
        dropSubmenuLeft: 0,
        dropSubmenuTop: 0,
        searchParams: {}, // 搜索区域绑定的搜索参数
        selectDataList: {}, // 下拉框数据储存对象
        pickerOptions: ELEMENT_DATE_PICKER_OPTIONS_1, // 日期选择框快捷操作配置
        showSaveSearchGroupDialog: false, // 是否显示保存搜索条件的dialog
        searchGroupInputValue: '', // 搜索条件组保存框中input的value
        selectedSavedSearchParams: '', // 当前选择的搜索条件组
        userGridConfigList: [], // 用户的搜索条件组
        searchGroupSaveOrUpdateFlag: 1, // 保存/更新 搜索条件组标识，1：保存，2：更新
        showSearchMask: false, // 是否显示搜索区域的遮罩
        selectRefPrefix: 'search-select-'
      }
    },
    computed: {
      selectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData')
      },
      remoteSelectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData/search')
      },
      saveUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'saveUserGridConfig')
      },
      updateUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'updateUserGridConfig')
      },
      deleteUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'deleteUserGridConfig')
      },
      queryUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'queryUserGridConfig')
      },
      uidColumnMap: function () {
        let map = {}
        if (this.gridConfig.listColumnConfig && this.gridConfig.listColumnConfig.length > 0) {
          this.gridConfig.listColumnConfig.forEach(item => {
            map[item.uid] = item
          })
        }
        return map
      }
    },
    methods: {
      handleSelectFocus(item) {
        if (item.selectData) { // 本地加载数据
          this.$set(this.selectDataList, item.uid, item.selectData)
        } else { // 远程加载数据
          if (!this.selectLoadStatusMap[item.uid]) {
            // 判断dependColumns是否有值
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnName = ''
              item.dependColumns.forEach(uid => {
                let column = this.uidColumnMap[uid]
                let key = column.dataIndex
                let value = this.searchParams[key]
                if (!value) {
                  if (dependColumnName) {
                    dependColumnName += '、'
                  }
                  dependColumnName += column.name
                }
              })
              if (dependColumnName) {
                this.$set(this.selectNoDataTextMap, item.uid, '请先选择：' + dependColumnName)
                return
              } else {
                this.$set(this.selectNoDataTextMap, item.uid, '无数据')
              }
            }
            // 设置为select状态为加载中
            this.$set(this.selectLoadingMap, item.uid, true)
            let params = {
              actionId: this.gridConfig.gridId,
              'columnDataIndex': item.dataIndex
            }
            // 补充级联参数
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnValues = {}
              item.dependColumns.forEach(uid => {
                let key = this.uidColumnMap[uid].dataIndex
                let value = this.searchParams[key]
                if (value) {
                  let sd = this.selectDataList[this.uidColumnMap[uid].uid]
                  if (sd) {
                    for (let i = 0; i < sd.length; i++) {
                      if (sd[i][1] === value) {
                        value = sd[i][0]
                        break
                      }
                    }
                    dependColumnValues[this.uidColumnMap[uid].dataIndex_] = value
                  }
                }
              })
              params.dependColumnValues = dependColumnValues
            }
            util.ajax.post(item.selectDataUrl || this.selectDataUrl, {params}).then((res) => {
              if (res.data.meta.errCode === 0) {
                this.$set(this.selectDataList, item.uid, res.data.data)
              } else {
                this.$notify.error({title: '错误', message: res.data.data})
              }
              this.$set(this.selectLoadingMap, item.uid, false)
            }).catch(() => {
              this.$set(this.selectLoadingMap, item.uid, false)
              console.error('获取下拉框数据失败！ ' + item.name)
            })
            this.selectLoadStatusMap[item.uid] = true
          }
        }
      },
      // select的change事件监听
      handleSelectChange(item) {
        // select变化时将它影响的其他select的值置空
        if (item.cascadeColumns && item.cascadeColumns.length > 0) {
          item.cascadeColumns.forEach(uid => {
            if (this.$refs[this.selectRefPrefix + uid] && this.$refs[this.selectRefPrefix + uid][0] && this.uidColumnMap[uid]) {
              // clear form field data
              this.$set(this.searchParams, this.uidColumnMap[uid].dataIndex, '')
              // reset field select data
              this.$set(this.selectDataList, uid, [])
              // reset field load status
              this.selectLoadStatusMap[uid] = false
            }
          })
        }
      },
      handleWhatySelectDataChange(selectData, item) {
        this.$set(this.selectDataList, item.uid, selectData)
      },
      clearSearchForm() { // 清空search form
        this.searchParams = {}
        this.selectedSavedSearchParams = ''
//        for (let key in this.searchParams) {
//          if (util.isArray(this.searchParams[key])) {
//            this.$set(this.searchParams, key, [])
//          } else {
//            this.$delete(this.searchParams, key)
//          }
//        }
      },
      handleSearch() { // 搜索
        this.$emit('on-search')
      },
      handleShowAdvancedSearchForm() { // 搜索
        this.$emit('show-advanced-search')
      },
      handleShowSaveSearchGroupDialog() { // 保存搜索条件
        this.searchGroupSaveOrUpdateFlag = 1
        this.searchGroupInputValue = ''
        this.showSaveSearchGroupDialog = true
      },
      handleSearchGroupFormSubmit() { // 保存搜索条件组form submit event
        if (this.searchGroupSaveOrUpdateFlag === 1) {
          this.saveSearchGroup()
        } else {
          this.updateSearchGroup()
        }
      },
      saveSearchGroup() { // 保存搜索条件
        let gridId = this.gridConfig.gridId || ''
        let userGridConfigName = this.searchGroupInputValue
        let searchParams = JSON.stringify(this.searchParams)
        if (userGridConfigName === '') {
          this.$notify.warning({title: '警告', message: '请输入名称！'})
          return
        }
        if (userGridConfigName.length > 30) {
          this.$notify.warning({title: '警告', message: '名称最长30个字符！'})
          return
        }
        let params = {}
        params.params = {
          gridId: gridId,
          gridUrl: this.gridConfigUrl,
          userGridConfigName: userGridConfigName,
          searchConfig: searchParams
        }
        util.ajax.post(this.saveUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功！'})
            this.handleSearchGroupSelectFocus()
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '保存失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      },
      updateSearchGroup() { // 更新搜索条件
        let configId = this.dropLinkSelect.id
        let userGridConfigName = this.searchGroupInputValue
        if (userGridConfigName === '') {
          this.$notify.warning({title: '警告', message: '请输入名称！'})
          return
        }
        let params = {}
        params.params = {
          configId: configId,
          userGridConfigName: userGridConfigName
        }
        util.ajax.post(this.updateUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '修改成功！'})
            this.handleSearchGroupSelectFocus()
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '修改失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      },
      showSearchGroupDrop(item, e) { // 显示搜索条件组的操作按钮
        this.dropLinkSelect = item
        this.showDropSubmenu = true
        this.dropSubmenuLeft = e.x - 10
        this.dropSubmenuTop = e.y + 10
      },
      handleSearchGroupSelectFocus(e) { // 加载搜索条件组下拉数据
        let ph = e ? e.target.placeholder : ''
        if (e) {
          e.target.placeholder = '请稍等，数据加载中...'
        }
        let params = {params: {
          actionId: this.gridConfig.gridId,
          gridUrl: this.gridConfigUrl
        }}
        util.ajax.post(this.queryUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.userGridConfigList = res.data.data
          }
          if (e) {
            e.target.placeholder = ph
          }
        }).catch((err) => {
          console.warn('获取用户搜索条件组失败！')
          console.error(err)
          if (e) {
            e.target.placeholder = ph
          }
        })
      },
      closeSearchGroupDropSubmenu(flag) { // 关闭显示的search group drop submenu
        if (flag) {
          this.dropLinkSelect = {}
        } else {
          this.showDropSubmenu = false
        }
      },
      handleSearchGroupChange(searchGroupId) { // 搜索条件组选中值发生变化时触发
        let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/
        let regExp = new RegExp(reg)
        for (let i = 0; i < this.userGridConfigList.length; i++) {
          if (this.userGridConfigList[i].id === searchGroupId) {
            this.searchParams = JSON.parse(this.userGridConfigList[i].searchConfig, function (key, value) {
              if (regExp.test(value)) {
                return new Date(value)
              } else {
                return value
              }
            })
            break
          }
        }
      },
      handleShowUpdateSearchGroupDialog() {
        this.searchGroupSaveOrUpdateFlag = 2
        this.searchGroupInputValue = this.dropLinkSelect.name
        this.showSaveSearchGroupDialog = true
      },
      deleteSearchGroup() {
        let params = {}
        params.params = {configId: this.dropLinkSelect.id}
        util.ajax.post(this.deleteUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '删除成功！'})
            this.handleSearchGroupSelectFocus()
          }
          if (this.selectedSavedSearchParams === this.dropLinkSelect.id) {
            this.selectedSavedSearchParams = ''
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '删除失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      }
    }
  }
</script>
<style lang="scss">
  .whaty-grid-search-form {
    /*overflow: hidden;*/
    .el-select {
      width: 100%;
    }
    .mSearch-cell {
      width: 220px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
    /* WebKit, Blink, Edge */
    input::-webkit-input-placeholder {
      color: #aaa;
    }
    /* Mozilla Firefox 4 to 18 */
    input:-moz-placeholder {
      color: #aaa;
    }
    /* Mozilla Firefox 19+ */
    input::-moz-placeholder {
      color: #aaa;
    }
    /* Internet Explorer 10-11 */
    input:-ms-input-placeholder {
      color: #aaa;
    }
  }
  /* el-date-picker样式重置 */
  /* el-data-picker元素会添加到当前组件之外,所以这段样式不能放入'.whaty-grid-search-form'内部! */
  .whaty-el-date-picker .el-picker-panel__sidebar {
    width: 70px;
  }
  .whaty-el-date-picker .el-picker-panel__body {
    margin-left: 70px;
  }
  .whaty-el-date-picker.el-date-range-picker.has-sidebar {
    width: 582px;
  }
  .whaty-el-date-picker .el-date-range-picker__content {
    padding: 6px;
  }
  .whaty-el-date-picker .el-picker-panel__shortcut:nth-child(2n) {
    border-bottom: 1px solid rgb(228, 231, 237);
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/grid-search-form.vue